import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ISpecialist } from '../specialists/types';

type NeedReviewState = {
  specialistID: string | null;
  specialistName: string | null;
  avatar: string | null;
};

const initialState: NeedReviewState = {
  specialistID: null,
  specialistName: null,
  avatar: null,
};

const needReviewReducer = createSlice({
  name: 'needReview',
  initialState: initialState,
  reducers: {
    setReviewData(state, action: PayloadAction<ISpecialist>) {
      const { id, first_name, last_name, avatar_link } = action.payload;
      return {
        specialistID: id,
        specialistName: `${first_name} ${last_name[0]}.`,
        avatar: avatar_link,
      };
    },
    resetReviewData(state) {
      return { ...initialState };
    },
  },
});

export const { setReviewData, resetReviewData } = needReviewReducer.actions;
export default needReviewReducer.reducer;
